<template>
    <div id="all-contact" class="d-flex align-items-stretch">
        <navigation></navigation>
        <contactlist></contactlist>
    </div>
</template>
<script>

// Components
import ContactList from './AllContactList.vue';

export default {
    components: {
        'contactlist': ContactList
    }
};
</script>
